import {
  Button,
  Paper,
  Grid,
  Collapse,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import * as React from "react";
// import { PortalAppBar } from "src/components/app-bar";
import { observable, action } from "mobx";
import {
  createStyles,
  withStyles,
  WithStyles,
  Theme,
} from "@material-ui/core/styles";
import { authStore } from "src/modules/auth";
import { observer } from "mobx-react";
import {
  AccountCircle,
  Cancel,
  Business,
  Contacts,
  ExpandMore,
  ExpandLess,
  Lock,
  LockOpen,
  Help,
  ScreenLockPortrait,
  GridOn,
  Settings
} from "@material-ui/icons";
import { history } from "src/history.js";
import { Loading } from "src/components/loading";
import { usersAdminStore } from 'src/modules/admin/modules/UsersAdmin';

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    userName: {
      align: "right",
      display: "flex",
      flex: 1,
      flexDirection: "row-reverse",
    },
    avatar: {
      border: "1px #fffb solid",
    },
    userInfo: {
      padding: "1rem",
      borderBottom: "1px solid #194b87",
    },
    nested: {
      paddingLeft: spacing.unit * 4,
    },
    navPanel: {
      paddingTop: "1rem",
      paddingBottom: "1rem",
      overflow: "auto",
      display: "flex",
      flexGrow: 1,
    },
    logOutButton: {
      padding: "1rem 1.5rem",
    },
  });

@observer
class StyledUserPanel extends React.Component<any> {
  @observable
  public adminMenuExpanded: boolean | undefined = false;

  constructor(props: any) {
    super(props);
  }

  @action
  public toggleCollapsableMenu = (menuName: string) => (e: any): void => {
    this[`${menuName}MenuExpanded`] = !this[`${menuName}MenuExpanded`];
  };

  public navOnClick = (link: string) => (e: React.MouseEvent): void => {
    history.push(link);
  };

   /**
   * #TODO E-019 TMPS > Users & Companies - set the previous
   * value of the previous filter will remove after logount so filter disappear.
   */
   public handleLogout = async () => {
    await authStore.logout(authStore.currentUser.auth_id)
    localStorage.removeItem("companyFilter");
    localStorage.removeItem("filter");
    history.push('/')
  }

  public hideMenuItemByPermission = (menuItem: string) => {
    if (!authStore.loaded) {
      return 'none'
    }
    if (authStore.currentUser.PermissionsList
      .filter((permission: any) =>
        permission.PermissionCategory === menuItem &&
        permission.PermissionType === 'read').length > 0) {
      return ''
    }
    return 'none'
  }

  public render() {
    const { classes } = this.props;
    if (!authStore.loaded) {
      return (
        <div style={{ height: "18rem" }}>
          <Loading size={40} />
        </div>
      );
    }
    return (
      <Grid container={true} direction={"column"}>
        <Grid
          container={true}
          className={classes.userInfo}
          direction={"row"}
          alignItems={"center"}
        >
          <Avatar src={authStore.currentUser.Image}>
            {!!authStore.currentUser.FirstName && !!authStore.currentUser.LastName
              ? authStore.currentUser.FirstName.slice(0, 1) + authStore.currentUser.LastName.slice(0, 1)
              : ""}
          </Avatar>
          <Typography
            className={classes.userName}
            align={"right"}
            inline={true}
            variant={"h6"}
          >
            {`${authStore.currentUser.FirstName} ${authStore.currentUser.LastName}`}
          </Typography>
        </Grid>
        <Grid
          container={true}
          direction={"column"}
          spacing={0}
          className={classes.navPanel}
        >
          <List component="nav" disablePadding={true}>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('dashboard') }}
              divider={true}
              button={true}
              onClick={this.navOnClick("/dashboard")}
            >
              <ListItemIcon>
                <GridOn />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('dashboard') }}
              divider={true}
              button={true}
              onClick={this.navOnClick("/account")}
            >
              <ListItemIcon>
                <AccountCircle />
              </ListItemIcon>
              <ListItemText primary="My Account" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('user') }}
              divider={true}
              button={true}
              // className={classes.nested}
              onClick={this.navOnClick("/admin/users")}
            >
              <ListItemIcon>
                <Contacts />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('company') }}
              divider={true}
              button={true}
              // className={classes.nested}
              onClick={this.navOnClick("/admin/companies")}
            >
              <ListItemIcon>
                <Business />
              </ListItemIcon>
              <ListItemText primary="Companies" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('permission') }}
              divider={true}
              button={true}
              // className={classes.nested}
              onClick={this.navOnClick("/admin/permissions")}
            >
              <ListItemIcon>
                <ScreenLockPortrait />
              </ListItemIcon>
              <ListItemText primary="Permissions" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('settings') }}
              divider={true}
              button={true}
              // className={classes.nested}
              onClick={this.navOnClick("/admin/settings")}
            >
              <ListItemIcon>
                <Settings />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
            <ListItem
              style={{ display: this.hideMenuItemByPermission('support') }}
              divider={true}
              button={true}
              onClick={this.navOnClick("/support")}
            >
              <ListItemIcon>
                <Help />
              </ListItemIcon>
              <ListItemText primary="Support" />
            </ListItem>
          </List>
        </Grid>
        <Grid container={true} spacing={0}>
          <ListItem
            divider={true}
            button={true}
            className={classes.logOutButton}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.handleLogout()}
          >
            <ListItemIcon style={{ color: "#f00b" }}>
              <Cancel />
            </ListItemIcon>
            <ListItemText primary="Log out" />
          </ListItem>
        </Grid>
      </Grid>
    );
  }
}

export const UserPanel = withStyles(styles, { withTheme: true })(
  StyledUserPanel
);



// WEBPACK FOOTER //
// ./src/modules/portal/components/UserPanel.tsx